import { useIsMutating, useMutation, useQueryClient } from '@tanstack/react-query';
import mutationFnFactory from './authorized-users-post-mutation';
import { authorizedUsersGetCacheKey } from '../get/authorized-users-get-cache-key';
import { authorizedUsersPostCacheKey } from './authorized-users-post-cache-key';
export function useAuthorizedUsersPostMutation({ config, mutationOptions = {} }) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: payload => {
            const { 'cipher.accountId': accountId, accountIdType, authorizedUsers } = payload;
            const keyProps = {
                accountId,
                accountIdType
            };
            return new Promise((resolve, reject) => {
                const hasNewAuthorizedUser = Boolean(authorizedUsers?.length);
                const mutationFn = mutationFnFactory(config, hasNewAuthorizedUser, keyProps);
                mutationFn(payload)
                    .then(async (response) => {
                    if (response) {
                        await queryClient.invalidateQueries(authorizedUsersGetCacheKey(keyProps));
                    }
                    resolve(response);
                })
                    .catch(reject);
            });
        },
        ...mutationOptions
    });
}
export const useIsAuthorizedUsersPostMutating = ({ keyProps }) => {
    return useIsMutating(authorizedUsersPostCacheKey(keyProps)) > 0;
};
